<template>
  <div>
    <div class="labelaudio__audio">
      <div class="audio">
        <div class="audio__wave" id="waveform"></div>
        <div class="audio__playlist">
          <button
            class="btn btn-primary audio__playlist--play"
            @click.prevent="play()"
          >
            <i class="fas fa-play"></i> /
            <i class="fas fa-pause"></i>
          </button>
          <button
            class="btn btn-danger audio__playlist--stop"
            @click.prevent="stop()"
          >
            <i class="fas fa-stop"></i>
          </button>
          <p class="audio__playlist--wavname">{{ audioName }}</p>
          <p class="audio__playlist--date">{{ batchDate }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as WaveSurfer from "wavesurfer.js";
import client from "@/api/client";

export default {
  props: {
    PropsAudioUrl: String,
    PropsStatus: String,
    PropsBatchDate: String,
    PropsAudioName: String,
    PropsHasLabeled: Array,
    PropsPlay: null
  },
  data() {
    return {
      dataToParents: [], // 準備給 父component 資料
      audioUrl: null,
      status: null, // cry, talk, cry&talk, music, echo, other
      batchDate: null,
      audioName: null,
      hasLabeled: [], // 若父組件原本有資料 就會接說父組件丟過來的資料
      isLoading: false,
      barHeight: "6",
      label: [], // 已標記的陣列
      labelColor: "#7fffd470",
      statusDecideColor: {
        talk: "#ff00003d",
        cry: "#7fffd470",
        cry_talk: "#9932cc3b",
        echo: "#f0e68c78",
        music: "rgba(0, 128, 0, 0.2)",
        other: "#6495ed61"
      },
      colorDecideStatus: {
        "#ff00003d": "talk",
        "#7fffd470": "cry",
        "#9932cc3b": "cry_talk",
        "#f0e68c78": "echo",
        "rgba(0, 128, 0, 0.2)": "music",
        "#6495ed61": "other"
      }
    };
  },
  methods: {
    createToParentData() {
      const vm = this;
      vm.dataToParents = vm.label;
    },
    play() {
      // 播放音檔
      this.wavesurfer.playPause();
    },
    stop() {
      // 停止音檔
      this.wavesurfer.stop();
    },
    // 繪製標記區域  ＊henry 調整內部架構
    changeDrawingRegionColor() {
      const vm = this;
      vm.labelColor = vm.statusDecideColor[vm.status];
      vm.wavesurfer.regions.color = vm.labelColor;
    },
    setupWavesurfer() {
      const vm = this;
      vm.wavesurfer = WaveSurfer.create({
        container: "#waveform", // 區域
        height: "200", // 高度,
        hideScrollbar: true,
        cursorColor: "red", // 進度線條顏色
        backend: "MediaElement",
        barWidth: true,
        barHeight: vm.barHeight
      });
    },
    destroyWavesurfer() {
      const vm = this;
      vm.wavesurfer.destroy();
    },
    // 繪製波行
    drawWave() {
      const vm = this;
      vm.isLoading = true;

      const url = `/data/audio_v2/${vm.batchDate}/${vm.audioName}`;
      console.log(url);
      client.getBlob(url).then(res => {
        vm.wavesurfer.load(URL.createObjectURL(res));
      });

      vm.setupWavesurfer();
    }
  },
  watch: {
    PropsStatus() {
      this.status = this.PropsStatus;
      this.changeDrawingRegionColor();
    },
    PropsBatchDate() {
      this.batchDate = this.PropsBatchDate;
    },
    PropsAudioName() {
      this.label = [];
      this.audioUrl = this.PropsAudioUrl;
      this.batchDate = this.PropsBatchDate;
      this.audioName = this.PropsAudioName;
      this.hasLabeled = this.PropsHasLabeled;
      this.destroyWavesurfer();
      this.drawWave();
    },
    label() {
      const vm = this;
      vm.createToParentData();
      vm.$emit("feedbackDataToParent", vm.dataToParents);
    },
    PropsPlay() {
      this.play();
    }
  },
  mounted() {
    this.setupWavesurfer();
  }
};
</script>
